<div mat-dialog-title>
  <span>{{ 'GRID_VIEWS.EDIT_FILTERS_TITLE' | translate: {name: view.name} }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<mat-dialog-content #dialogContent>
  <div class="edit-filters-dialog">
    <q9-info-message *ngIf="error && !viewFilters().length && !isSubmitted" type="error">
      {{ error | translate }}
    </q9-info-message>

    <ng-container *ngFor="let filter of viewFilters(); index as i; trackBy: trackByFilter">
      <div class="filter" *ngIf="filter.field! | transform: getColumnByField.bind(this) as column">
        <!-- Column select -->
        <q9-select
          class="column-select"
          [ngModel]="column.field"
          (ngModelChange)="changeColumn($event, i)">
          <q9-option [value]="column.field">
            {{ column.title | translate }}
          </q9-option>

          <q9-option
            *ngFor="let col of availableColumns(); trackBy: trackByColumn"
            [value]="col.field">
            {{ col.title | translate }}
          </q9-option>
        </q9-select>

        <ng-container *ngIf="!templates?.hasOwnProperty(column.field); else filterTemplate">
          <!-- Operator and value selects -->
          <q9-grid-text-filter
            *ngIf="column.filter === 'text'"
            [column]="column"
            [filter]="compositeFilter()"
            [filterService]="gridViewsFilterService"></q9-grid-text-filter>
          <q9-grid-rich-text-filter
            *ngIf="column.filter === 'textarea'"
            [column]="column"
            [filter]="compositeFilter()"
            [filterService]="gridViewsFilterService"></q9-grid-rich-text-filter>
          <!-- NUMERIC FILTER -->
          <q9-grid-numeric-filter
            *ngIf="column.filter === 'numeric'"
            [column]="column"
            [filter]="compositeFilter()"
            [filterService]="gridViewsFilterService"></q9-grid-numeric-filter>
          <!-- DATE FILTER -->
          <q9-grid-date-filter
            *ngIf="column.filter === 'date'"
            [column]="column"
            [filter]="compositeFilter()"
            [filterService]="gridViewsFilterService"></q9-grid-date-filter>
        </ng-container>

        <ng-template #filterTemplate>
          <ng-container
            *ngComponentOutlet="
              templates![column.field]!;
              inputs: {
                filter: compositeFilter(),
                column: column,
                filterService: gridViewsFilterService
              }
            "></ng-container>
        </ng-template>

        <q9-icon-button icon="close" (click)="removeFilter(i, column.filter)"></q9-icon-button>
      </div>
    </ng-container>

    <q9-placeholder *ngIf="!viewFilters().length">
      <span q9PlaceholderText>
        {{ 'GRID_VIEWS.NO_FILTERS_MSG' | translate: {name: view.name} }}
      </span>
      <q9-primary-button q9PlaceholderButton (click)="addFilter()">
        {{ 'GRID_VIEWS.ADD_FILTER_TITLE' | translate }}
      </q9-primary-button>
    </q9-placeholder>
  </div>
</mat-dialog-content>

<div
  class="add-filter-small-button"
  *ngIf="viewFilters().length"
  [style.visibility]="availableColumns().length ? 'visible' : 'hidden'">
  <button
    mat-mini-fab
    color="primary"
    [matTooltip]="'GRID_VIEWS.ADD_FILTER_TITLE' | translate"
    class="add-filter"
    (click)="addFilter()">
    <mat-icon svgIcon="plus"></mat-icon>
  </button>
</div>

<div mat-dialog-actions>
  <q9-secondary-button mat-dialog-close>
    {{ 'GENERAL.CANCEL' | translate }}
  </q9-secondary-button>

  <q9-primary-button (click)="onSubmit()" [isLoading]="isSubmitted">
    {{ 'GENERAL.CONFIRM' | translate }}
  </q9-primary-button>
</div>
